import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { GraduationCap, ArrowRight } from "lucide-react";

export default function BootcampHubCard() {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/bootcamp").then((r) => setP(r.data.progress)).catch(() => {});
  }, []);
  return (
    <Link to="/bootcamp" data-testid="hub-bootcamp-card"
          className="group block rounded-2xl bg-[#0A1F44] text-white p-5 sm:p-6 ring-1 ring-[#C9A961]/30 hover:ring-[#C9A961] transition-shadow shadow-sm">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-[#C9A961] text-[#0A1F44] flex items-center justify-center shrink-0">
          <GraduationCap className="w-6 h-6" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">New Partner Resource</div>
          <div className="font-serif text-xl sm:text-2xl mt-0.5">Bootcamp</div>
          <p className="text-white/70 text-sm mt-1">Day-by-day training to help you start strong, including important topics, podcasts, resources, and practical actions and tasks.</p>
          {p && (
            <div className="mt-3 flex items-center gap-3" data-testid="hub-bootcamp-progress">
              <div className="h-1.5 flex-1 max-w-xs rounded-full bg-white/15 overflow-hidden">
                <div className="h-full bg-[#C9A961]" style={{ width: `${p.pct}%` }} />
              </div>
              <span className="text-xs text-white/80 tabular-nums">{p.completed}/{p.total} · {p.pct}%</span>
            </div>
          )}
        </div>
        <ArrowRight className="w-5 h-5 text-[#C9A961] mt-1 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
